import api from 'api'
import { Dispatch, SetStateAction } from 'react'
import { Campaign } from 'types/campaign'

export default class CampaignFormService {
  static getCampaignImpressionsBasedOnFrequency = ({
    campaignId,
    setEstimatedImpressions,
    setLoading,
  }: {
    campaignId: Campaign['id']
    setEstimatedImpressions: Dispatch<SetStateAction<number | null>>
    setLoading: Dispatch<SetStateAction<boolean>>
  }): void => {
    setLoading(true)

    api.campaign
      .getCampaignImpressionsBasedOnFrequency(campaignId)
      .then(res => {
        setEstimatedImpressions(res.data.campaignImpressionsBasedOnFrequency.impressions)
      })
      .catch(() => void {})
      .finally(() => void setLoading(false))
  }
}
